import {
  collectActiveWindWalls,
  isProjectileBlockedByWindWalls
} from '../../../domain/champions/yasuoWindWall.js';

/**
 * Drop enemy skillshots that currently overlap a live Wind Wall (FID-ABL-16).
 */
export function cullWindWallBlockedProjectiles(
  activeProjectiles = [],
  entities = [],
  nowSec = 0,
  scene = null
) {
  const walls = collectActiveWindWalls(entities, nowSec);
  if (walls.length === 0) return;
  for (let i = activeProjectiles.length - 1; i >= 0; i -= 1) {
    const p = activeProjectiles[i];
    if (!isProjectileBlockedByWindWalls(p?.domain, walls, nowSec)) continue;
    if (p.mesh && scene) scene.remove(p.mesh);
    activeProjectiles.splice(i, 1);
  }
}
